import type { BundleMessageLocation } from './BundleMessageLocation.js';

/** Additional information about a bundle warning or error. */
export interface BundleMessageNote {
  text: string;
  /** File location the issue originated from. */
  location?: BundleMessageLocation;
}
